export default {
      id: "icon-plug-anal-usage",
      viewBox: "0 0 65.7 127.6",
      url: __webpack_public_path__ + "icons.svg#icon-plug-anal",
      toString: function () {
        return this.url;
      }
    }